import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { bindCardLogo } from '../../utils';
import { CardDetailModel } from '@App/common/models';

@Component({
  selector: 'app-credit-card',
  templateUrl: './credit-card.component.html',
  styleUrls: ['./credit-card.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf],
  encapsulation: ViewEncapsulation.None
})
export class CreditCardComponent implements OnInit {
  logoUrl: string;
  @Input() allowRemoveCard: boolean = true;
  @Input() miniSize: boolean = false;
  @Input() midSize: boolean = false;
  @Output() delete: EventEmitter<any> = new EventEmitter();

  constructor() {}

  _cardDetails: CardDetailModel;

  get cardDetails() {
    return this._cardDetails;
  }

  @Input()
  set cardDetails(value: any) {
    this._cardDetails = value;
    this.logoUrl = bindCardLogo(this._cardDetails.brand);
  }

  get MM() {
    if (this._cardDetails && this._cardDetails.expMonth) {
      if (this._cardDetails.expMonth.toString().length == 1) {
        return '0' + this._cardDetails.expMonth.toString();
      } else {
        return this._cardDetails.expMonth;
      }
    }

    return 'XX';
  }

  get YY() {
    return this._cardDetails && this._cardDetails.expYear
      ? this._cardDetails.expYear.toString().substr(2, 2)
      : 'XX';
  }

  ngOnInit(): void {}

  deleteCard() {
    this.delete.emit();
  }
}
